import { useShadowRootElements } from '@backstage/plugin-techdocs-react';
import 'katex/dist/katex.min.css';
import { useInjectKatexCssIntoShadowDom } from './useInjectKatexCss';
import { useRenderMathElements } from './useRenderMathElements';

export const AddKatexRendering = () => {
  const headElements = useShadowRootElements<HTMLHeadElement>(['head']);
  const mathElements = useShadowRootElements<HTMLElement>(['.arithmatex']);

  useInjectKatexCssIntoShadowDom(headElements);
  useRenderMathElements(mathElements);

  return null;
};
